import(/* webpackMode: "eager" */ "/home/ubuntu/download/699ad1e4f782d5001402abd4/pc_cargo_website/src/app/products/[id]/page.tsx");
